import { Confirm } from "../../components/confirm/confirm";

export default function ConfirmPage(){
    return <Confirm />;
}